// extracted by mini-css-extract-plugin
module.exports = {"root":"QCUn6eAM","nobreak":"Fh4BlC9s"};